import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FrontModule } from './front/front.module';
//import { DashboardComponent } from './front/pages/dashboard/dashboard.component';
import { MaterialExampleModule } from './Components/MaterialUI';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TableComponent } from './Components/table/table.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MapContainerComponent } from './Components/map-container/map-container.component';
//import { AgmCoreModule } from '@agm/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrderByPipe } from './Pipe/orderBy.pipe';
import { HttpClientModule } from '@angular/common/http';
import {MatNativeDateModule, MAT_DATE_LOCALE} from '@angular/material/core';
import { UniquePipe } from './Pipe/dropDown.pipe';
import { DialogComponent } from './Components/dialog/dialog.component';
import { AngularSvgIconPreloaderModule } from 'angular-svg-icon-preloader';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { GoogleMapsModule } from '@angular/google-maps';
@NgModule({
    declarations: [
        AppComponent,
        //DashboardComponent,
        TableComponent,
        MapContainerComponent,
        DialogComponent,
        OrderByPipe,
        UniquePipe
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FrontModule,
        MaterialExampleModule,
        BrowserAnimationsModule,
        MatSlideToggleModule,
        AngularSvgIconModule.forRoot(), // angular-svg-icon library module
        AngularSvgIconPreloaderModule.forRoot({
        configUrl: './assets/json/icons.json',
        }),
        /*AgmCoreModule.forRoot({
            apiKey: 'AIzaSyCzVT_pP6jOQp9_0iBgqfgu5mw1gDNK66s',
            libraries: ['places', 'drawing', 'geometry']
        }),*/
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgSelectModule,
        GoogleMapsModule,
        NgMultiSelectDropDownModule.forRoot()
    ],
    providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }],
    bootstrap: [AppComponent]
})
export class AppModule { }
